// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"6ed6ef1d","334":"d53bdf6e","377":"157d91a2","509":"4cc565da","790":"7c15d6e6","926":"e43feb61"}[chunkId] + ".chunk.css";
};